"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function useFocusTrap(_a) {
    var ref = _a.ref, _b = _a.options, options = _b === void 0 ? {} : _b;
    var _c = options.selectors, selectors = _c === void 0 ? "a[href], div[tabIndex], button, textarea, input, select" : _c;
    (0, react_1.useEffect)(function () {
        if (ref.current) {
            ref.current.focus();
        }
        var onKeyDown = function (event) {
            if (ref.current && (event.key === "Tab" || event.keyCode === 9)) {
                var focusableModalElements = Array.from(ref.current.querySelectorAll(selectors)).filter(function (el) { return el.tabIndex > -1; });
                if (!focusableModalElements.length) {
                    return event.preventDefault();
                }
                var firstElement = focusableModalElements[0];
                var lastElement = focusableModalElements[focusableModalElements.length - 1];
                if (!event.shiftKey && document.activeElement === lastElement) {
                    firstElement.focus();
                    return event.preventDefault();
                }
                if (event.shiftKey && document.activeElement === firstElement) {
                    lastElement.focus();
                    return event.preventDefault();
                }
                if (!focusableModalElements.includes(document.activeElement)) {
                    if (!event.shiftKey) {
                        firstElement.focus();
                    }
                    if (event.shiftKey) {
                        lastElement.focus();
                    }
                    return event.preventDefault();
                }
            }
            return undefined;
        };
        window.addEventListener("keydown", onKeyDown);
        return function () { return window.removeEventListener("keydown", onKeyDown); };
    }, [ref, selectors]);
}
exports.default = useFocusTrap;
//# sourceMappingURL=index.js.map